import React from 'react';
import Typical from 'react-typical';
import { Link } from 'react-router-dom';
import {
  FeaturesImgLeft,
  MainBtn,
  Section,
} from '../Styled';
import { Hero, HeroDes, HeroMiddle, HeroTitle } from './Home.styled';
import { SweetBox } from '../blocks/Sweetbox.styled';
import NavBar from '../NavBar';
import Services from '../blocks/Services';
import Waves from '../svgfiles/Waves';
import Slider from '../blocks/Slider';
import AppMockups from '../images/app_mockups_showcase.png';
import DynamicBackground from '../svgfiles/DynamicBackground';
import ReactImg from '../images/react_img.png';
import Footer from '../blocks/Footer';
import ImgPlaceholder from '../images/nye_designs_img.png';
import CTAUp from '../blocks/CTAUp';
import JEWELLY from '../images/Cases/Jewelly-Complete.png';

const CARDS = [
  {
    id: 0,
    source: ImgPlaceholder,
    title: 'Gennemsigtighed',
    text: 'Vi holder dig kontinuerligt opdateret under udviklingen, så du hele tiden kan følge med.',
  },
  {
    id: 1,
    source: ImgPlaceholder,
    title: 'brand building',
    text: 'Har du ikke allerede et brand? Så hjælper vi dig med at opbyggelsen af din digitale identitet.',
  },
  {
    id: 2,
    source: ImgPlaceholder,
    title: 'Motiverede',
    text: 'Vi elsker at arbejde, lære og leje – men vores største tilfredshed kommer fra at se vores kunder tjene ved at bruge vores løsninger!',
  },
  {
    id: 3,
    source: ImgPlaceholder,
    title: 'Din hjælpende hånd',
    text: 'Vi vil se dig vinde! Vores fokus er derfor at hjælpe dig fremad, ved at gøre det lettere for dig at drive din forretning.',
  },
  {
    id: 4,
    source: ImgPlaceholder,
    title: 'Rådgivning',
    text: 'Vi sørger for at rådgive dig til den bedst mulige løsning for hosting med mere. Alt afhængigt af dit ønskede produkt.',
  },
];

const Home = () => {
  return (
    <div>
      <Hero>
        <DynamicBackground />
        <NavBar />
        <HeroMiddle>
          <HeroTitle>Vi er eksperter i</HeroTitle>
          <HeroDes>
            <Typical
              loop={Infinity}
              wrapper="b"
              steps={[
                'Appudvikling 📱',
                3000,
                'Webudvikling 💻',
                3000,
                'Web Apps ☄️',
                3000,
                'Hjemmesider 🪐',
                3000,
                'Launchering 🚀',
                3000,
              ]}
            />
          </HeroDes>
        </HeroMiddle>
        <Waves />
      </Hero>
      <CTAUp
        title='Effektiviser din virksomhed med en App'
        body='Med stærke tekniske kompetencer, stor forretningsforståelse og dyb
      indsigt i de mennesker teknologien skal gavne, ved vi, hvordan en
      App kan skabe stor værdi både for forretningen og for brugerne.'
        btn='Læs mere'
        to='/appudvikling'
        photo={AppMockups}
        alt='Apps fra Noaly'
      />

      <Services />
      <Slider CARDS={CARDS} />
      <Section>
        <SweetBox>
          <div>
            <h1>Skal vi lave din hjemmeside?</h1>
            <p>
              Lad os hjælpe dig med at gøre din idé til et levende website med React webudvikling
            </p>
            <Link to='/webudvikling'>
              <MainBtn>Læs mere</MainBtn>
            </Link>
          </div>
          <div>
            <img src={JEWELLY} alt="Jewelly Hjemmeside" />
          </div>
        </SweetBox>
      </Section>
      <FeaturesImgLeft>
        <div>
          <img src={ReactImg} alt="React" />
        </div>
        <div>
          <h1>Flydende</h1>
          <h2>App udvikling</h2>
          <p>
            Vi udvikler vores Apps i React ved brug af jsx og SCSS. Vi laver
            alle vores apps som Progressive Web Apps, som giver din App
            muligheden for at kunne downloades både i App-store &
            GooglePlay-store for smartphones. <br /> <br />
            At kode en App i Javascript, kommer med flere fordele for vores
            kunder.
            <br /> <br />
            For eksempel har vi muligheden for at formatere Appen til bubble.io,
            hvor du derefter selv kan lave ændringer på farver med mere helt
            uden at kode.
          </p>
        </div>
      </FeaturesImgLeft>
      <Footer />
    </div>
  );
};

export default Home;
